
export const locale = {
    //header.vue
    cname:'上虹货架',
    myorder:'我的订单',
    car:'购物车',
    myplan:'我的方案',
    coupon:'优惠券',
    logout:'退出',
    louout1:'登出',
    register:'注册',
    login:'登录',
    home:'首页',
    about:'关于上虹',
    about1:'上虹简介',
    about_culture:'上虹文化',
    about_step:'上虹足迹',
    about_productive:'生产实力',
    about_authority:'荣誉资质',
    about_partner:'合作伙伴',
    solution:'解决方案',
    retail:'商业零售',
    stage:'展示道具',
    storage:'仓储/自动化物流',
    vending:'智能售货机',
    online_shop:'在线商城',
    design:'3D云设计平台',
    server:'服务支持',
    serve_shop:'服务网点',
    serve:'一站式服务',
    contactus:'联系我们',
    contact:'联系方式',
    jobs:'招贤纳士',
    agent:'成为代理商',
    supplier:'供应商平台',
    
    //bottom.vue
    wechat:'微信公众号',
    sh_shop:'上虹商城',
    copyright:'版权所有',
    companyname:'浙江上虹货架有限公司',
    icpno:'浙ICP备13026816号-1',
    zgw:'浙公网安备33042102000240号',
    
    //goods.vue
    goodslist:'商品列表',
    search: '搜索',
    categories:'品类',
    category_c:'子类',
    tags:'系列',
    sort: {
        default1:'默认排序',
        priceAsc:'价格低－高',
        priceDesc:'价格高－低'
    },
    
    //goodsdetail.vue
    goodsdetail1:'商品详情',
    gogoods:'返回商品首页',
    goods_sn:'产品编号',
    price:'价格',
    stock:'库存',
    piece:'件',
    specs:'规格',
    length:'长',
    width:'宽',
    high:'高',
    color:'颜色',
    nums:'数量',
    server1:'服务',
    return_goods:'支持30天无忧退货',
    priority_distribution:'优先顺丰配送',
    buynow:'一键购买',
    incar:'加入购物车',
    goodsdetail:'产品详情',
    goods_model:'产品型号',
    size:'尺寸',
    goods_summary:'产品描述',
    stock_insufficient:'库存不足',
    add_success:'添加成功',
    
    //car.vue
    mycar:'我的购物车',
    empty_car:'您的购物车空空如也',
    go_shop:'去商城逛逛',
    arrive:'预计10个工作日送达',
    del_goods:'确认删除此商品',
    yes:'是',
    no:'否',
    selectall:'全选',
    total:'总计',
    checkout:'结账',
    
    //coupon.vue
    enter_coupon:'请输入优惠码',
    post:'提交',
    available:'可使用',
    used:'已使用',
    expired:'已过期',
    discount:'折',
    full:'满',
    minus:'减',
    universal:'全场通用',
    user:'立即使用',
    all:'全部',
    waitpay:'等待支付',
    paid:'已支付',
    completed:'已完成',
    delivery:'配送中',
    delivered:'已送达',
    refund:'退款中',
    refunded:'已退款',
    cancelled:'已取消',
    payfailed:'支付失败',
    activation_success:'优惠码激活成功',
    
    //editplan
    editplan:'方案修改',
    
    //myorder.vue
    goods_information:'产品信息',
    unit_price:'单价',
    disbursements:'实付款',
    transaction_status:'交易状态',
    ctime:'下单时间',
    order_sn:'订单编号',
    order_detail:'订单详情',
    contract:'合同协议',
    gopay:'去支付',
    order_cancel:'取消订单',
    confirm_receipt:'确认收货',
    buy_again:'再次购买',
    terms_agreements:'条款和协议',
    
    //myplan.vue
    plan:'方案',
    edit:'编辑',
    del:'删除',
    
    //order.vue
    confirm_order:'确认订单',
    payment:'支付方式',
    shipping_address:'收货地址',
    add:'添加',
    location:'所在地区',
    phone:'手机',
    detail_address:'详细地址',
    edit1:'修改',
    default_address:'默认地址',
    add_new_address:'添加新地址',
    other_address:'其他收货地址',
    addressee:'收件人',
    address:'地址',
    street:'街道',
    set_default_address:'设置为默认地址',
    details:'产品细节',
    introduction:'简介',
    white:'白色',
    silvery:'银色',
    coupon_area:'优惠信息区',
    user_coupon:'使用优惠券/优惠码',
    user_coupon1:'使用优惠券',
    piece1:'张可用',
    activation_coupon:'激活优惠码',
    user_cancel:'取消使用',
    total_price:'总价',
    freight:'运费',
    payable:'应付',
    postorder:'提交订单',
    select_address:'请选择收货地址',
    
    //orderdetail.vue
    pay_success:'付款成功',
    goods_delivery:'商品出库',
    order_information:'订单信息',
    message:'买家留言',
    order_status:'订单状态',
    logistics:'物流',
    express:'运单号',
    status:'状态',
    making:'制作中',
    
    //pay.vue
    pay:'支付',
    payable1:'实际应付',
    selectpayment:'请选择支付方式',
    alipay:'支付宝',
    wechatpay:'微信支付',
    accept:'我接受条款和协议',
    pay1:'付款',
    readed:'我已阅读以上协议',
    check:'请勾选条款协议',
    
    //paysuccess.vue
    paysuccess:'支付成功',
    actual_payment:'实际支付',
    view_order:'查看订单详情',
    back_detail:'返回商品详情页',
    
    
    //2022-3-14 new
    Commercial_retail : '商业/零售',
    shelves : '商超货架',
    store_shelves : '会员制卖场货架',
    warehousing_industry : '仓储/工业',
    beam_type_shelves : '横梁式货架',
    narrow_roadway_beam_shelves : '窄巷道横梁货架',
    double_depth_beam_shelves : '双深度横梁货架',
    drive_in_shelves : '驶入式货架',
    shuttle_shelves : '穿梭车货架',
    flow_shelves : '流利式货架',
    cantilever_rack_shelves : '悬臂式货架',
    duty_racking_shelves: '搁板货架',
    attic_shelves : '阁楼货架',
    vertical_warehouse_shelves : 'AS/RS立库货架',
    logistics_equipment :'物流设备',
}


// WEBPACK FOOTER //
// ./src/assets/lang/zh.js